import 'css-chunk:src/index/pages/issue/index.module.scss';export default {
  "tablet": "tablet__ickyE",
  "sp": "sp__lHY2e",
  "pc": "pc__JYRon",
  "pcTablet": "pcTablet__sKxfd",
  "section": "section__FANVy",
  "relative": "relative__TEVER",
  "row": "row__zvaNL",
  "middle": "middle__Z4GOj",
  "formLabel": "formLabel__GstET",
  "formLabel2": "formLabel2__GTvU0",
  "formLabelIssue": "formLabelIssue__7to9p",
  "hoge": "hoge__oS4bd",
  "row2": "row2__0MJfo",
  "item": "item__y0IiX",
  "inputWidth": "inputWidth__nEq5n",
  "space_bottom": "space_bottom__1oM3F",
  "width_max": "width_max__5lhbr",
  "required": "required__s9o7Y",
  "form_custom": "form_custom__kxAqC",
  "form_custom_child": "form_custom_child__pdRLY",
  "space": "space__hXRfb",
  "space_left": "space_left__sPp7l",
  "form": "form__mmmdi"
};